// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c81d1a28","453":"73f810e2","455":"776b37af","641":"5f979425","683":"bd3746ce","977":"9a56fd24"}[chunkId] + ".chunk.js";
};